import React, { useEffect, useState } from "react";


import { EyeOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, } from "@mui/material";
import { Form, Image, Input, message, Select } from "antd";
import Carousel from 'react-material-ui-carousel';

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { Dropdown, Menu, Button, Modal, } from "antd";
import { MoreOutlined } from '@ant-design/icons';


import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { APP_URL, INV_ATTACHEMEN_URL, VEH_AGREEMENT_URL, VEH_IMAGE_URL } from "../../Api/constants";

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TextField,
} from '@mui/material';
import AgreementDataTable from "../../Components/AgreementsDataTable";
import DataTable from "../../Components/DataTable";
import { capitalizeFirstLetter, getDateString } from "../../config/functions";


const { Option } = Select;




const TransactionDetails = () => {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);
    const dispatch = useDispatch();
    const { id } = useParams();

    const [transactions, setTransactions] = useState([]);
    const [rejectedReason, setRejectedReason] = useState('');
    const [rejectionReasonModal, setRejectionReasonModal] = useState(false);
    const [rejectedInvoice, setRejectedInvoice] = useState();
    const columns = [
        {
            title: 'Transaction id',
            dataIndex: 't_id',
            key: 't_id',
        },
        // {
        //     title: 'Invoice id',
        //     dataIndex: 'inv_id',
        //     key: 'inv_id',
        // },
        {
            title: 'Cust name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Cust phone',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Paid amount',
            dataIndex: 't_paid_amount',
            key: 't_paid_amount',
        },
        {
            title: 'Status',
            dataIndex: 't_status ',
            key: 't_status',
            render: (_id, record) => (
                <div>{capitalizeFirstLetter(record.t_status)}</div>
            )
        },
        {
            title: 'Attachement',
            dataIndex: 'attachement',
            key: 'attachment',
            render: (_id, record) => (


                <Carousel
                    indicators={false} // Hide the dots

                    style={{ height: 180, width: 100, borderRadius: 10, marginTop: 5 }} >
                    {record?.attachement?.map((image, index) => (
                        <Image key={index} src={INV_ATTACHEMEN_URL + image} alt="slider-item" style={{ width: '100%', height: 100, objectFit: 'cover' }} />


                        // <Item key={index} image={VEH_IMAGE_URL + image} />
                    ))}
                </Carousel>



                // <Image
                //     width={100}
                //     height={100}
                //     // key={index}
                //     src={APP_URL + record.attachement}
                //     // alt={`Vehicle ${index + 1}`}
                //     style={{ marginBottom: "16px", borderRadius: 10, }}
                // />
                // <img
                //     src={APP_URL + record.attachement}
                //     // alt="Attachment"
                //     style={{ maxWidth: '100px', maxHeight: '100px' }}
                // />
            )

        },
        {
            title: 'Reference',
            dataIndex: 'reference',
            key: 'reference',
        },
        {
            title: 'Comments',
            dataIndex: 'comments',
            key: 'comments',
        },

        {
            title: 'Created at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (_id, record) => (
                <div>{getDateString(record.created_at)}</div>
            )
        },
        {
            title: 'Action',
            dataIndex: 'created_at',
            key: 'action',
            render: (_, record) => (
                <Dropdown
                    overlay={
                        <Menu onClick={({ key }) => handleActionClick(key, record)}>
                            <Menu.Item disabled={record.t_status == 'approved'} key="approve">Approve</Menu.Item>
                            <Menu.Item disabled={record.t_status == 'approved'} key="reject">Reject</Menu.Item>
                        </Menu>
                    }
                    trigger={['click']}
                >
                    <Button>
                        <MoreOutlined style={{ fontWeight: 'bolder' }} />
                    </Button>
                </Dropdown>
            ),

        },
    ];



    const getTransactionDetails = (fetch) => {
        if (fetch) return;
        const onSuccess = (res) => {
            dispatch(setLoader(false))
            setTransactions(res.data);
        }
        const onError = (err) => {
            console.log('err_', err);
            dispatch(setLoader(false))
            message.error(err.data?.error)
        }

        const body = {
            token: user?.token,
            inv_id: id
        }
        dispatch(setLoader(true))
        postRequest(body, apiRoutes.getTransactionDetails, onSuccess, onError)
    }

    const handleActionClick = async (key, record) => {
        let status = key == 'approve' ? "approved" : "rejected";
        if (status == 'rejected' && !rejectedReason) {
            setRejectedInvoice(record);
            setRejectionReasonModal(true);
            return;
        }

        const onSuccess = (res) => {
            message.success("Transaction has been approved successfully!");
            setRejectedReason('');
            getTransactionDetails();
        }
        const onError = (err) => {
            console.log('err', err)
            setRejectedReason('');
            message.error(err.data?.error)
            dispatch(setLoader(false))
        }

        const body = {
            token: user?.token,
            t_id: record.t_id,
            inv_id: record.inv_id,
            status: status,
            rejection_reason: rejectedReason
        };
        dispatch(setLoader(true))
        await postRequest(body, apiRoutes.changeTransactionStatus, onSuccess, onError)

    };


    useEffect(() => {
        let fetch = false;
        if (!fetch) getTransactionDetails(fetch);
        return () => {
            fetch = true;
        }
    }, [])




    return (
        <>
            <ThemeProvider theme={theme}>

                <Modal
                    title="Please enter reason for rejecting the transaction"
                    visible={rejectionReasonModal}
                    onCancel={() => setRejectionReasonModal(false)}


                    footer={[
                        <Button key="cancel" onClick={() => setRejectionReasonModal(false)}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={() => {
                            if (!rejectedReason) {
                                message.error("Please enter reason");
                                return
                            }
                            setRejectionReasonModal(false);
                            handleActionClick('rejected', rejectedInvoice);
                        }}>
                            Reject
                        </Button>,
                    ]}
                >
                    <Form.Item
                        name="clientEmail"
                    >
                        <Input
                            style={{ height: 50, width: "100%" }}

                            onChange={(e) => setRejectedReason(e.target.value)}
                            className="textInput"
                            value={rejectedReason}
                        />
                    </Form.Item>


                    {/* <p>Deleting this note will parmanently delete. You will never recover this note.</p> */}
                </Modal>




                <div style={{ display: 'flex', width: "100%", flex: 1 }}>
                    <Sidebars />
                    <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'column', width: "80%" }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                                Transactions
                            </span>
                        </div>

                        <div style={{ display: 'flex', width: "100%", borderRadius: 5, flexDirection: 'row', padding: 5, paddingTop: 10, backgroundColor: 'white', marginTop: 20, paddingLeft: 20, flexWrap: 'wrap' }} >

                            {
                                transactions?.map((transaction, i) => {

                                    return (
                                        <div style={{ width: "100%", flexDirection: 'row', display: 'flex', marginTop: 10, flexWrap: 'wrap' }}>
                                            <div style={{ width: 220, height: 180, borderRadius: 5, alignItems: 'center', justifyContent: 'center', backgroundColor: appColors.grey }}>
                                                {
                                                    transaction?.attachement?.length &&
                                                    <Carousel
                                                        autoPlay={false}
                                                        indicators={false}
                                                        style={{ height: 180, borderRadius: 10, marginTop: 5 }} >
                                                        {transaction.attachement?.map((image, index) => (
                                                            <Image
                                                                key={index}
                                                                src={INV_ATTACHEMEN_URL + image} alt="slider-item"
                                                                style={{ width: '100%', height: 180, objectFit: 'cover' }}
                                                            />
                                                        ))}
                                                    </Carousel>
                                                }
                                            </div>
                                            <div style={{ marginLeft: 15, display: 'flex', flexDirection: 'column', minWidth: "40%", maxWidth: "70%", overflowY: 'auto' }}>
                                                <div style={vehicleRowContainer}>
                                                    <div style={vehicleRow1}>
                                                        <Typography sx={fieldText} >Id</Typography>
                                                        <Typography sx={valueText} >{transaction?.t_id}</Typography>
                                                    </div>
                                                    <div style={vehicleRow2}>
                                                        <Typography sx={fieldText} >Inv id</Typography>
                                                        <Typography sx={valueText} >{transaction?.inv_id}</Typography>
                                                    </div>
                                                </div>
                                                <div style={vehicleRowContainer}>
                                                    <div style={vehicleRow1}>
                                                        <Typography sx={fieldText} >Cust name</Typography>
                                                        <Typography sx={valueText} >{transaction?.name}</Typography>
                                                    </div>
                                                    <div style={vehicleRow2}>
                                                        <Typography sx={fieldText} >Paid amount</Typography>
                                                        <Typography sx={valueText} >{transaction.t_paid_amount}</Typography>
                                                    </div>
                                                </div>
                                                <div style={vehicleRowContainer}>
                                                    <div style={vehicleRow1}>
                                                        <Typography sx={fieldText} >Status</Typography>
                                                        <Typography sx={valueText} >{capitalizeFirstLetter(transaction.t_status)}</Typography>
                                                    </div>
                                                    <div style={vehicleRow2}>
                                                        <Typography sx={fieldText} >Reference</Typography>
                                                        <Typography sx={valueText} >{transaction.reference}</Typography>
                                                    </div>
                                                </div>
                                                <div style={vehicleRowContainer}>
                                                    <div style={vehicleRow1}>
                                                        <Typography sx={fieldText} >Comments</Typography>
                                                        <Typography sx={valueText} >{transaction.comments}</Typography>
                                                    </div>
                                                    <div style={vehicleRow2}>
                                                        <Typography sx={fieldText} >Transaction type</Typography>
                                                        <Typography sx={valueText} >{transaction.t_type}</Typography>
                                                    </div>
                                                </div>
                                                <div style={vehicleRowContainer}>
                                                    <div style={vehicleRow2}>
                                                        <Typography sx={fieldText} >Created at</Typography>
                                                        <Typography sx={valueText} >{getDateString(transaction.created_at)}</Typography>
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', maxWidth: "50%" }}>
                                                    <Typography sx={fieldText} >Rejection reason</Typography>
                                                    <Typography sx={valueText} >{transaction.rejection_reason}</Typography>
                                                </div>

                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 15 }}>
                                                <div
                                                    onClick={() => {
                                                        if (transaction.t_status == 'approved') return;
                                                        handleActionClick('approve', transaction);

                                                    }}
                                                    style={{ width: 80, height: 29, borderStyle: 'solid', borderRadius: 20, display: 'flex', borderWidth: 1, borderColor: appColors.primary, alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                                    <Typography sx={{ fontSize: 12, color: appColors.primary, fontFamily: 'Poppins', fontWeight: 600 }} >Approve</Typography>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        // if (transaction.t_status == 'under_review') {
                                                            handleActionClick('reject', transaction);
                                                        // }

                                                    }}
                                                    style={{ width: 120, height: 29, borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: transaction.t_status == 'rejected' ? 'default': 'pointer', marginTop: 10, backgroundColor:transaction.t_status == 'rejected' ? 'rgba(255,0,0,0.5)': appColors.red }}>
                                                    <Typography sx={{ fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600 }} >Reject</Typography>
                                                </div>
                                            </div>


                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>

                    {/* <div>
                            <DataTable data={transactions} columns={columns} />
                        </div> */}



                </div>



            </ThemeProvider >
        </>
    )

}

const infoContainer = {
    width: 250, borderRadius: 10, backgroundColor: appColors.white, padding: 5, paddingBottom: 20
}

const infoHeadingContainer = {
    width: "100%", backgroundColor: appColors.primaryLight,
    borderTopRightRadius: 10, borderTopLeftRadius: 10,
    height: 40, alignItems: 'center', justifyContent: 'center', display: 'flex'
}

const infoHeading = {
    fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600
}

const infoValueContainer = {
    display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginTop: 15,
}

const infoValue = {
    fontSize: 14, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const vehicleRowContainer = {
    borderStyle: 'dashed', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderColor: appColors.grey,
    display: 'flex', flexDirection: 'row', width: "100%", justifyContent: 'space-between', height: 'auto',
    marginTop: 5, paddingBottom: 3

}

const vehicleRow1 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const vehicleRow2 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const fieldText = {
    fontSize: 12, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const valueText = {
    fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600,
}

const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default TransactionDetails
